// Import and initialize slick-carousel
import 'slick-carousel'
import 'slick-carousel/slick/slick.scss'

$('.slick-carousel-initialize').slick({
    nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
    prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
    dots: true,
    adaptiveHeight: true,
    //lazyLoad: 'ondemand', // ondemand (default), anticipated, progressive
    infinite: true // if true, also prev slide image will be loaded (don't know why)
})